// /dist/script.js (oder deine Quelle vor dem Build)
let lastScrollY = window.scrollY;
const header = document.querySelector(".header");

window.addEventListener("scroll", () => {
  const current = window.scrollY;

  // ab einem kleinen Offset erst reagieren
  if (current > 80 && current > lastScrollY) {
    // runter scrollen
    header.classList.add("hidden");
  } else {
    // hoch scrollen
    header.classList.remove("hidden");
  }

  // Zustand für Hintergrund/Blur
  if (current > 10) {
    header.classList.add("header--scrolled");
  } else {
    header.classList.remove("header--scrolled");
  }

  lastScrollY = current;
});

const footerYear = document.getElementById("footer-year");
if (footerYear) {
  footerYear.textContent = new Date().getFullYear();
}

const revealElements = document.querySelectorAll(".reveal");

if ("IntersectionObserver" in window && revealElements.length > 0) {
  const revealObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.2, // 20% im Viewport reichen
    }
  );

  revealElements.forEach((el) => revealObserver.observe(el));
} else {
  // Fallback: Falls kein IntersectionObserver unterstützt wird
  revealElements.forEach((el) => el.classList.add("is-visible"));
}

const contactForm = document.querySelector(".contact__form");

if (contactForm) {
  contactForm.addEventListener("submit", async (event) => {
    event.preventDefault(); // Browser-Redirect zu FormSubmit verhindern

    const formData = new FormData(contactForm);

    try {
      await fetch(contactForm.action, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      });

      // erfolgreiche Anfrage -> eigene Danke-Seite
      window.location.href = "/danke.html";
    } catch (error) {
      console.error("Fehler beim Senden des Formulars:", error);

      // Falls was schiefgeht, kurze Meldung für den User
      const hint = document.querySelector(".contact__hint");
      if (hint) {
        hint.textContent =
          "Leider gab es ein Problem beim Senden. Bitte versuchen Sie es später erneut oder schreiben Sie direkt an kontakt@sprecher-ciblak.de.";
      }
    }
  });
}


// --- Demo Tiles: Play/Pause (ein Track gleichzeitig) ---
(() => {
  const tiles = document.querySelectorAll(".demo-tile");
  if (!tiles.length) return;

  let currentAudio = null;
  let currentTile = null;

  function stopCurrent() {
    if (!currentAudio) return;
    currentAudio.pause();
    currentAudio.currentTime = 0;
    if (currentTile) {
      currentTile.classList.remove("is-playing");
      const icon = currentTile.querySelector(".demo-tile__play-icon");
      if (icon) icon.textContent = "▶";
    }
    currentAudio = null;
    currentTile = null;
  }

  tiles.forEach((tile) => {
    const btn = tile.querySelector(".demo-tile__play");
    const icon = tile.querySelector(".demo-tile__play-icon");
    const src = tile.getAttribute("data-audio");

    if (!btn || !src) return;

    btn.addEventListener("click", async (e) => {
      e.preventDefault();

      // Wenn ein anderer Track läuft -> stoppen
      if (currentAudio && currentTile && currentTile !== tile) {
        stopCurrent();
      }

      // Wenn dieser Tile noch keinen Player hat -> erstellen
      if (!currentAudio) {
        currentAudio = new Audio(src);
        currentTile = tile;

        currentAudio.addEventListener("ended", () => {
          stopCurrent();
        });

        try {
          await currentAudio.play();
          tile.classList.add("is-playing");
          if (icon) icon.textContent = "⏸";
        } catch (err) {
          console.error("Audio konnte nicht abgespielt werden:", err);
          stopCurrent();
        }
        return;
      }

      // Gleicher Tile: togglen
      if (currentTile === tile) {
        if (currentAudio.paused) {
          try {
            await currentAudio.play();
            tile.classList.add("is-playing");
            if (icon) icon.textContent = "⏸";
          } catch (err) {
            console.error("Audio konnte nicht abgespielt werden:", err);
            stopCurrent();
          }
        } else {
          currentAudio.pause();
          tile.classList.remove("is-playing");
          if (icon) icon.textContent = "▶";
        }
      }
    });
  });

  // Wenn Nutzer irgendwo anders klickt oder navigiert: optional stoppen
  window.addEventListener("blur", () => {
    // stopCurrent(); // aktivieren, wenn du bei Tab-Wechsel stoppen willst
  });
})();